export default __webpack_public_path__ + "static/img/rudder.e284b94.png";